import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import { SshSecurityInfo, SshSecurityInfoActionsType } from 'data/sshSecurityInfo/sshSecurityInfo.types';
import './ssh-security-information-menu.scss';

type Props = {
  selectedItem?: SshSecurityInfo;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const SshSecurityInfoMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="SshSecurityInfoMenu" className="ssh-security-info-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="ssh-security-info-action-menu-button"
        data-testid={`${SshSecurityInfoActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="ssh-security-info-action-menu-button"
        data-testid={`${SshSecurityInfoActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('sshSecurityInfo.deletePopup.title')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedItem.SS8ID })
        }
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default SshSecurityInfoMenu;
